import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { CrossWords } from '../games/CrossWords';
import HuntWords from '../games/HuntWords';
import { Quiz } from '../games/Quiz';
import { Rebus } from '../games/Rebus';
import SudokuHookProvider from '../games/Sudoku';
import WordleHookProvider from '../games/Wordle';
import { Home } from '../pages/Home';
import { LeagueNotifications } from '../pages/LeagueNotifications';
import { LeaguesHome } from '../pages/LeaguesHome';
import { LeagueSettings } from '../pages/LeaguesSettings';
import { LeagueUserNotifications } from '../pages/LeagueUserNotifications';
import { LeagueUsers } from '../pages/LeagueUsers';
import Profile from '../pages/Profile';
import { Ranking } from '../pages/Ranking';
import { Tournaments } from '../pages/Tournaments';
import { TournamentsList } from '../pages/TournamentsList';

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="/ranking" element={<Ranking />} />
        <Route path="/tournaments" element={<Tournaments />} />
        <Route path="/tournaments/list" element={<TournamentsList />} />
        {/* <Route path="users/*" element={<Users />} /> */}
        {/*Game Routes */}
        <Route path="/jogo/rebus/:id" element={<Rebus />} />
        <Route path="/jogo/cacapalavras/:id" element={<HuntWords />} />
        <Route path="/jogo/wordle" element={<WordleHookProvider />} />
        <Route path="/jogo/sudoku/:id" element={<SudokuHookProvider />} />
        <Route path="/jogo/palavrascruzadas/:id" element={<CrossWords />} />
        <Route path="/jogo/quiz/:id" element={<Quiz />} />
        {/*League Routes */}
        <Route path="/leagues" element={<LeaguesHome />} />
        <Route path="/leagues/settings" element={<LeagueSettings />} />
        <Route path="/leagues/users" element={<LeagueUsers />} />
        <Route
          path="/leagues/notifications"
          element={<LeagueNotifications />}
        />
        <Route
          path="/leagues/user/notifications"
          element={<LeagueUserNotifications />}
        />
      </Routes>
    </BrowserRouter>
  )
};

export default AppRoutes;